import createAction from "redux-actions/es/createAction";
import { login as api } from "../api/index";
import { toastr } from "react-redux-toastr";
import { setAuth } from "../../../api";
import { auth, getuserInfomation } from "../../../actions/authActions";
import { getDashboard as dashBaordApi } from "../api/index";
// import { getuserInfomation } from '../../actions/authActions';

export const login = createAction("LOGIN_START");
export const loginFail = createAction("LOGIN_FAIL");
export const loginSuccess = createAction("LOGIN_SUCCESS");
export const clearLogin = createAction("LOGIN_CLEAR");

export const initalData = createAction("INITIAL_DATA_START");
export const initalDataFail = createAction("INITIAL_DATA_FAIL");
export const initalDataSuccess = createAction("INITIAL_DATA_SUCCESS");
export const clearInitalData = createAction("INITIAL_DATA_CLEAR");

export const piechartBulk = createAction("PIECHART_BULK_START");
export const piechartBulkFail = createAction("PIECHART_BULK_FAIL");
export const piechartBulkSuccess = createAction("PIECHART_BULK_SUCCESS");
export const piechartBulkData = createAction("PIECHART_BULK_CLEAR");

export const trendchartBulk = createAction("TRENDCHART_BULK_START");
export const trendchartBulkFail = createAction("TRENDCHART_BULK_FAIL");
export const trendchartBulkSuccess = createAction("TRENDCHART_BULK_SUCCESS");
export const trendchartBulkData = createAction("TRENDCHART_BULK_CLEAR");



// const signInSuccessfully = (res) => {
//   //    toastr.success('Login', res);
//   // const selector= useSelector();

//   return (dispatch) => {
//     if (res.data) {
//       setAuth(res.data);
//       auth(res.data);
//     }
//     initOptions();
//   };

//   // return this.props.action({type:loginSuccess , paylod:res});
// };

const signInFailed = (res) => {
  return toastr.error("Login", res);
};

export const fetchSignIn = (values) => {
  return (dispatch) => {
    return api(values)
      .then((res) => {
        if (res.status !== 200) {
          signInFailed(res.status);
        } else if (res.data.status !== "Invalid" && res.data !== "") {
          let payload = {
            user: { accounts: res.data.userData },
            token: res.data.token,
            refreshToken: res.data.token.token,
            isSignUp: true,
          };
          dispatch(auth(payload));
          setAuth(res);
        }
      })
      .catch((err) => {
        signInFailed(err?.response?.data?.status);
      });
  };
};

export const dashboard = (data) => {
  return (dispatch) => {
    dashBaordApi(data)
      .then((res) => {
        dispatch(initalDataSuccess(res.data));
      })
      .catch((err) => {
        // dispatch(projectFail(err));
      });
  };
};
